<template>

  <button :data-card-index="orderId" class="card" :class="additionalClasses" >
    <div v-if="showMessage" class="message">
      <strong v-if="debugMode">{{msg}}</strong>
    </div>
    <template v-if="isGapFiller">
      
    </template>
    <template v-else-if="symbolFormat==='png'">
      <SingleSymbolPNG v-for="n in amount" :key="n" :color="symbolColor" :filling="symbolFilling" :shape="symbolShape"/>
    </template>
    <template v-else-if="symbolFormat==='svg'">
      <SvgComponents :color="symbolColor" :filling="symbolFilling" :shape="symbolShape"/>
      <SingleSymbolSVG v-for="n in amount" :key="n" :symbolId="symbolId" />
    </template>
    <template v-else>
      symbolFormat {{symbolFormat}} undefined (png | svg)
    </template>
    <div v-if="debugMode" class="debug">
      Design #{{design.id}}: <strong>{{design.name}}</strong> <br>
      {{amount}} {{symbolFilling}} {{symbolColor}} {{symbolShape}} {{card}} {{orderId}}
    </div>
  </button>
</template>

<script>
import config from '@/assets/config.json'
import designSets from '@/assets/designSets.json'
import SingleSymbolPNG from '@/components/SingleSymbolPNG.vue'
import SingleSymbolSVG from '@/components/SingleSymbolSVG.vue'
import SvgComponents from '@/components/SvgComponents.vue'


export default {
  name: 'SingleCard',
  components: {
    SingleSymbolPNG: SingleSymbolPNG,
    SingleSymbolSVG: SingleSymbolSVG,
    SvgComponents: SvgComponents

  },
  props: {
    msg: String,
    card: Array,
    orderId: {
      type: Number,
      required: false
    },
    isPicked: {
      type: Boolean,
      required: false,
      default: false
    },
    isGapFiller: {
      type: Boolean,
      required: false,
      default: false
    },
    isMarkedInvalid: {
      type: Boolean,
      required: false,
      default: false
    },
    isMarkedValid: {
      type: Boolean,
      required: false,
      default: false
    },
    showMessage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      config: config,
      debugMode: config.debugMode,
      design: designSets[config.activeDesignId],
      cardColors: designSets[config.activeDesignId].cardColors,
      symbols: designSets[config.activeDesignId].symbols,
      symbolFormat: designSets[config.activeDesignId].symbols.format,
      symbolColors: designSets[config.activeDesignId].symbols.colors,
      symbolFillings: designSets[config.activeDesignId].symbols.fillings,
      symbolShapes: designSets[config.activeDesignId].symbols.shapes
    }
  },
  computed: {
    additionalClasses: function() {
      let css="";
      if (this.isPicked) css += ' active';
      if (this.isGapFiller) css += ' empty';
      if (this.isMarkedInvalid) css += ' invalid';
      if (this.isMarkedValid) css += ' set-member';
      return css;
    },
    amount: function () {
      return this.card[0] ;
    },
    symbolFilling: function () {
      return this.symbolFillings[ this.card[1] ];
    },
    symbolColor: function () {
      return this.symbolColors[ this.card[2] ];
    },
    symbolShape: function() {
      return this.symbolShapes[ this.card[3] ];
    },
    symbolId: function () {
      return 'symbol_'+this.symbolColor + '_' + this.symbolFilling + '_' + this.symbolShape;
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.cards {

  .card {
    position: relative;
    border: solid 1px;
    border-color: v-bind('cardColors.border');
    border-radius: 10px;
    background-color: v-bind('cardColors.basic');
    width: 260px;
    height: 160px;
    padding: 0;
    /*margin: 5px;*/
    display: flex;
    justify-content: center;
    align-items: center;
    transition: width 3s;

    .message {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 10px;

    }

    .debug {
      position: absolute;
      bottom: 5px;
      right: 5px;
      font-size: 10px;
    }

  }

  &.cards-pickable {
    .card {
      cursor: pointer;

      &:hover {
        background-color: v-bind('cardColors.hover');
        border-width: 2px;
      }
      &.active {
        background-color: v-bind('cardColors.active');
        border-width: 4px;
      }
      &.set-member {
        border-color: v-bind('cardColors.valid');
        border-width: 4px;
      }

      &.empty {
        cursor: default;
        border: none;
        &:hover {
          background-color: v-bind('cardColors.basic');
        }
      }

      &.invalid {
        border-color: v-bind('cardColors.invalid');
        border-width: 4px;
      }

    }
  }

}

</style>

